import { createSlice } from "@reduxjs/toolkit";
import {
  getMe,
  getRegions,
  getTenantDetailsById,
  saveProfile,
  saveTenant,
} from "./thunks";
import { message } from "antd";
import { setCurrentPlans } from "./helper";
import {
  getLocalStorageItem,
  SELECTED_TENANT_ID,
  setLocalStorageItem,
} from "../../constant/localStorage";

const initialState = {
  tenants: {},
  user: null,
  selectedTenantId: null,
  loading: true,
  regions: null,
  currentPlan: null,
  planNote: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setKeyValue: (state, action) => {
      const { key, value } = action.payload;
      if (
        value &&
        key === "selectedTenantId" &&
        !state?.tenants?.[value]?.has_premium_access
      ) {
        state.selectedTenantId = null;
        return;
      }

      if (key === "selectedTenantId") {
        setLocalStorageItem(SELECTED_TENANT_ID, value);
      }

      state[key] = value;
    },
    updateHasPremiumAccess: (state, action) => {
      const { tenant_id } = action.payload;
      state.tenants[tenant_id].has_premium_access = false;
    },
    setPlans: setCurrentPlans,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMe.fulfilled, (state, action) => {
        const { tenants, ...user } = action.payload;
        state.user = user;
        const prevTenantId = getLocalStorageItem(SELECTED_TENANT_ID);

        const selectedTenant = tenants?.find(
          (tenant) => tenant?.id === prevTenantId,
        );

        if (selectedTenant?.has_premium_access) {
          state.selectedTenantId = selectedTenant.id;
        } else {
          const firstPremiumTenant = tenants?.find(
            (tenant) => tenant?.has_premium_access,
          );

          if (firstPremiumTenant?.id) {
            state.selectedTenantId = firstPremiumTenant.id || null;
            setLocalStorageItem(SELECTED_TENANT_ID, firstPremiumTenant.id);
          }
        }

        state.tenants = tenants.reduce((acc, tenant) => {
          acc[tenant?.id] = tenant;
          return acc;
        }, {});
        state.loading = false;
      })
      .addCase(saveTenant.fulfilled, (state, action) => {
        const { data, message: successMessage } = action.payload;
        state.tenants[state.selectedTenantId] = {
          ...(action.meta.arg || {}),
          ...data,
        };
        message.success(successMessage || "Tenant saved successfully");
      })
      .addCase(getRegions.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.regions = data;
      })
      .addCase(saveProfile.fulfilled, (state, action) => {
        const { data, message: successMessage } = action.payload;
        state.user = { ...(state.user || {}), ...data };
        message.success(successMessage || "User profile update successfully");
      })
      .addCase(getTenantDetailsById.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.tenants[state.selectedTenantId] = {
          ...state.tenants[state.selectedTenantId],
          ...data,
        };
      });
  },
});

export const { setKeyValue, updateHasPremiumAccess, setPlans } =
  userSlice.actions;

export default userSlice.reducer;
